import mitt from "mitt";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method setBtnCancel
 * @method setTag
 * @method clearText
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * @method onHidden
 * event
 * @event sendCallbackOk
 * @event sendCallbackHidden
 */
export function OtpModalController () {
    this.busModal = new mitt();

    //#region relation
    this.alertModal = null;
    this.loadingModal = null;
    //#endregion relation

    this.callbackOk = null;
    this.callbackCancel = null;
    this.callbackHidden = null;
    this.callbackSubmitOtp = null;
    this.callbackError = null;
    this.callbackResendOtp = null;

    //#region setter
    this.setAlertModal = function(alertModal) {
        this.alertModal = alertModal;
    };
    this.setLoadingModal = function(loadingModal) {
        this.loadingModal = loadingModal;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    this.startOtp = function(contact_number, objOTP) {
        var config = {
            contact_number: contact_number,
            objOTP: objOTP,
        };
        this.busModal.emit('startOtp', config);
    };
    this.cancelOtp = function() {
        this.busModal.emit('cancelOtp');
    };

    this.error = function(error) {
        var config = {
            error: error,
        };
        this.busModal.emit('errorOtp', config);
    }
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (typeof callback == 'function') {
            this.callbackOk = callback;
        }
    };
    this.sendCallbackOk = function(data) {
        if (typeof this.callbackOk == 'function') {
            this.callbackOk(data);
        }
    };
    this.onClickCancel = function(callback) {
        if (typeof callback == 'function') {
            this.callbackCancel = callback;
        }
    };
    this.sendCallbackCancel = function(data) {
        if (typeof this.callbackCancel == 'function') {
            this.callbackCancel(data);
        }
    };
    this.onHidden = function(callback) {
        if (typeof callback == 'function') {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function(data) {
        if (typeof this.callbackHidden == 'function') {
            this.callbackHidden(data);
        }
    };
    this.onSubmitOtp = function(callback) {
        if (typeof callback == 'function') {
            this.callbackSubmitOtp = callback;
        }
    },
    this.sendCallbackSubmitOtp = function(data) {
        if (typeof this.callbackSubmitOtp == 'function') {
            this.callbackSubmitOtp(data);
        }
    };
    this.onError = function(callback) {
        if (typeof callback == 'function') {
            this.callbackError = callback;
        }
    };
    this.sendCallbackError = function(data) {
        if (typeof this.callbackError == 'function') {
            this.callbackError(data);
        }
    };
    this.onResendOtp = function(callback) {
        if (typeof callback == 'function') {
            this.callbackResendOtp = callback;
        }
    },
    this.sendCallbackResendOtp = function(data) {
        if (typeof this.callbackResendOtp == 'function') {
            this.callbackResendOtp(data);
        }
    };
    //#endregion event
}
